/**
 * Requires
 */

import $ from 'jquery'
// import 'stickymate'
window.jQuery = $

/**
 * Modules
 */

import * as MobileMenu from './mobile-menu'
import * as Menu from './menu'
import * as Toggle from './toggle'
import * as SmoothScroll from './smooth-scroll'
import * as VideoEmbed from './video-embed'
import * as ExternalLinks from './external-links'
import * as Carousel from './carousel'
import * as Slides from './slides'
import * as Accordion from './accordion'
import * as FlipperText from './flipper-text'
import * as Enquiries from './enquiries'
import * as PannableAttributes from './pannable-attributes'
import * as StickyLabeler from './sticky-labeler'

/**
 * Initialisation
 */

Menu.initialise()
MobileMenu.initialise()
Toggle.initialise()
SmoothScroll.initialise()
VideoEmbed.initialise()
ExternalLinks.initialise()
Carousel.initialise()
Slides.initialise()
Accordion.initialise()
FlipperText.initialise()
Enquiries.initialise()
PannableAttributes.initialise()
StickyLabeler.initialise()
